<template>
    <div class="card-header" style="z-index: 8000;">
        <div class="card card-header-inner" style="margin-top: 3px; background:  #ffffff;">
            <div v-if="set_app_order" class="row">
                <div class="col-md-2">
                    <a class="card-link" style="text-decoration: none;" :href="'/'+sellpoint.business_username">
                        <div style="padding:0.1em 0.8em; line-height: 0.1; background: none; border: #ffe600 solid 1px; border-left: 3px solid #ffe600; border-radius: 7px; color: #0d0e00;">
                            <h4 class="ctro" style="font-size: 13px;"><i class="fas fa-plus"></i> Add new Item</h4>
                        </div>
                    </a>
                </div>
                <div class="col-md-2">
                    <a class="card-link" style="text-decoration: none;" :href="'/'+sellpoint.business_username">
                        <div style="padding:0.1em 0.8em; line-height: 0.1; background: #ffe600; border-radius: 7px; color: #0d0e00;">
                            <h4 class="ctro" style="font-size: 13px;"><i class="fas fa-plus"></i> New Category</h4>
                        </div>
                    </a>
                </div>
                <div class="col-md-2" style="float: right;">
                    <a class="card-link" style="text-decoration: none;" :href="'/'+sellpoint.business_username">
                        <div style="padding:0.1em 0.8em; line-height: 0.1; background: #ff1e1e; border-radius: 7px; color: #ffffff;">
                            <h4 class="ctro" style="font-size: 14px;">Sort <i class="fas fa-angle-down" style="color: #ffffff;float: right;"></i> </h4>
                            <div style="clear: both;"></div>
                        </div>
                    </a>
                </div>
                <div style="clear: both;"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import services from './../../services/service'; // Service Class
    import AccountResources from './../Account/Resources/commonfunctions.js';

    //
    let service = new services();

    export default {
        name: 'DashboardHeader',
        mixins: [AccountResources],
        data () {
            return {
                loggedIn:false,
                set_app_text_01:true,
                set_app_order:false
            }
        },
    
        components: {},
        methods: {
            preset() {
                this.loading = true;
                //../
                let self = this;
                localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        self.loggedIn = true;
                        self.user = value;
                        self.setSiteUser();
                        //self.setPageSettings();
                    }else {
                        self.loading = false;
                        //self.$router.push('/login')
                    }
                });
            },

            setPageSettings(){
                //this.setSiteUser();
                //
                //get route //this.$route.params.id
                let page_path = this.$route.path;
                // if((page_path == "/dashboard") && (this.site_user_type == 2)){
                if(this.site_user_type == 2){
                    this.set_app_order = true;
                    this.set_app_text_01 = false;
                }
            },
        },
        created: function(){
            this.preset();
        }
    }
</script>


// WEBPACK FOOTER //
// HeaderPanel.vue?1f4e44a8